"use client";

import React from "react";
import styles from "./Stepper.module.css";

interface Step {
  label: string;
}

interface StepperProps {
  steps: Step[];
  currentStep: number; // 1-based index
}

const Stepper: React.FC<StepperProps> = ({ steps, currentStep }) => {
  // Global index (1-based)
  const idx = currentStep; 

  const windowSteps = [
    steps[idx - 2] || null, 
    steps[idx - 1] || null, 
    steps[idx] || null,     
  ].filter(Boolean);

  return (
    <div className={styles.stepperContainer}>
      {windowSteps.map((step, localIndex) => {
        
        const globalIndex = idx - 1 + localIndex - (idx === 1 ? 0 : 1);

        const isActive = globalIndex + 1 === idx; 

        return (
          <div key={globalIndex} className={styles.stepWrapper}>
            <div className={`${styles.step} ${isActive ? styles.active : ""}`}>
              {localIndex === 0 && (
                <span className={styles.icon}>
                 
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.99518 18.3243C14.5953 18.3243 18.3243 14.5953 18.3243 9.99518C18.3243 5.39511 14.5953 1.66602 9.99518 1.66602C5.39511 1.66602 1.66602 5.39511 1.66602 9.99518C1.66602 14.5953 5.39511 18.3243 9.99518 18.3243Z"
                      stroke="#4A4039"
                      strokeWidth="1.66583"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M7.49609 9.99519L9.16206 11.6612L12.494 8.32922"
                      stroke="#4A4039"
                      strokeWidth="1.66583"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              )}

              {localIndex === 1 && (
                <span className={styles.icon}>
                  
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <path
                      d="M13.693 17.4917V15.8257C13.693 14.942 13.342 14.0945 12.7171 13.4697C12.0923 12.8448 11.2448 12.4938 10.3611 12.4938H5.36318C4.4795 12.4938 3.63201 12.8448 3.00715 13.4697C2.38229 14.0945 2.03125 14.942 2.03125 15.8257V17.4917"
                      stroke="#568F6E"
                      strokeWidth="1.66583"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M7.86123 9.16265C9.70141 9.16265 11.1932 7.67089 11.1932 5.83071C11.1932 3.99054 9.70141 2.49878 7.86123 2.49878C6.02105 2.49878 4.5293 3.99054 4.5293 5.83071C4.5293 7.67089 6.02105 9.16265 7.86123 9.16265Z"
                      stroke="#568F6E"
                      strokeWidth="1.66583"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18.6904 17.4917V15.8257C18.6898 15.0874 18.4441 14.3703 17.9918 13.7868C17.5395 13.2033 16.9062 12.7866 16.1914 12.6021"
                      stroke="#568F6E"
                      strokeWidth="1.66583"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.6914 2.60706C14.4081 2.79056 15.0434 3.20739 15.497 3.79182C15.9507 4.37625 16.1969 5.09503 16.1969 5.83487C16.1969 6.5747 15.9507 7.29349 15.497 7.87792C15.0434 8.46234 14.4081 8.87917 13.6914 9.06268"
                      stroke="#568F6E"
                      strokeWidth="1.66583"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              )}

              {localIndex === 2 && (
                <span className={styles.icon}>
                
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                  >
                    <path
                      d="M15.8764 10.661C17.1174 9.44493 18.3751 7.98732 18.3751 6.07994C18.3751 4.86498 17.8925 3.69977 17.0334 2.84066C16.1743 1.98155 15.0091 1.4989 13.7941 1.4989C12.3282 1.4989 11.2953 1.91536 10.046 3.16473C8.79659 1.91536 7.76377 1.4989 6.29784 1.4989C5.08287 1.4989 3.91766 1.98155 3.05855 2.84066C2.19944 3.69977 1.7168 4.86498 1.7168 6.07994C1.7168 7.99565 2.96617 9.45326 4.21555 10.661L10.046 16.4914L15.8764 10.661Z"
                      stroke="#30251D"
                      strokeWidth="1.66583"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              )}

              <span className={styles.label}>
                Step {globalIndex + 1}: {step.label}
              </span>
            </div>

            {localIndex < windowSteps.length - 1 && (
              <div className={styles.divider}></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
